import React from 'react';
import { Typography, Paper, TextField, Button, List, ListItem, ListItemText, IconButton, Checkbox } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DeleteIcon from '@mui/icons-material/Delete';

const IntervieweeList = ({
  newInterviewee,
  setNewInterviewee,
  handleAddInterviewee,
  handleBulkAddOpen,
  handleDeleteSelectedInterviewees,
  interviewees,
  handleDeleteInterviewee,
  selectedInterviewees,
  handleIntervieweeSelect
}) => {
  return (
    <>
      <Typography variant="h4" gutterBottom>Interviewees</Typography>
      <Paper sx={{ p: 2, mb: 2 }}>
        <TextField
          label="First Name"
          value={newInterviewee.firstName}
          onChange={(e) => setNewInterviewee({ ...newInterviewee, firstName: e.target.value })}
          margin="normal"
        />
        <TextField
          label="Last Name"
          value={newInterviewee.lastName}
          onChange={(e) => setNewInterviewee({ ...newInterviewee, lastName: e.target.value })}
          margin="normal"
        />
        <TextField
          label="Email"
          value={newInterviewee.email}
          onChange={(e) => setNewInterviewee({ ...newInterviewee, email: e.target.value })}
          margin="normal"
        />
        <Button
          startIcon={<AddIcon />}
          variant="contained"
          onClick={handleAddInterviewee}
          sx={{ mt: 2, ml: 2 }}
        >
          Add Interviewee
        </Button>
        <Button
          startIcon={<UploadFileIcon />}
          variant="contained"
          onClick={handleBulkAddOpen}
          sx={{ mt: 2, ml: 2 }}
        >
          Bulk Add Interviewees
        </Button>
        <Button
          startIcon={<DeleteIcon />}
          variant="contained"
          onClick={handleDeleteSelectedInterviewees}
          disabled={selectedInterviewees.length === 0}
          sx={{ mt: 2, ml: 2 }}
        >
          Delete Selected Interviewees
        </Button>
      </Paper>
      <List>
        {interviewees.map((interviewee) => (
          <ListItem key={interviewee.id} secondaryAction={
            <IconButton edge="end" aria-label="delete" onClick={() => handleDeleteInterviewee(interviewee.id)}>
              <DeleteIcon />
            </IconButton>
          }>
            <Checkbox
              edge="start"
              checked={selectedInterviewees.includes(interviewee.id)}
              onChange={() => handleIntervieweeSelect(interviewee.id)}
            />
            <ListItemText
              primary={`${interviewee.firstName} ${interviewee.lastName}`}
              secondary={interviewee.email}
            />
            {interviewee.interview_status === 'completed' && <Checkbox checked disabled />}
          </ListItem>
        ))}
      </List>
    </>
  );
};

export default IntervieweeList;
